export const StepTitle = ({ children }: { children: React.ReactNode }) => (
  <h2 className="text-xl text-primary-800 text-center mb-1">{children}</h2>
);

export const StepDescription = ({
  children,
}: {
  children: React.ReactNode;
}) => <p className="text-center text-[13px] text-gray-600 mb-4">{children}</p>;
